export default __webpack_public_path__ + "static/media/rack6.69144c10.webp";